import { jsx as e } from "react/jsx-runtime";
import { Label as t } from "../../Label/Label.js";
import { mergeClasses as a } from "../../../utils/merge-classes.js";
const i = /* @__PURE__ */ e(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-.92-3.03c.19.18.49.27.91.27.44 0 .74-.09.92-.27a.9.9 0 0 0 .27-.66v-.39a.89.89 0 0 0-.27-.64c-.19-.19-.5-.28-.92-.28-.42 0-.72.1-.9.28a.88.88 0 0 0-.27.64v.39c0 .25.09.47.26.66zM7 8.5h2V4H7v4.5z"
      }
    )
  }
), c = ({
  className: r,
  ...o
}) => /* @__PURE__ */ e(
  t,
  {
    as: "span",
    className: a(
      "break-words text-color-scheme-functional-negative-600",
      r
    ),
    fontWeight: "bold",
    iconStart: i,
    size: "sm",
    role: "alert",
    ...o
  }
);
export {
  c as FieldErrorText
};
